'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'has',
    immutable: 'has',
    record: 'has',
    object: function object(key) {
        return function (value) {
            return value.hasOwnProperty(key);
        };
    },
    array: function array(key) {
        return function (value) {
            return key < value.length && key >= -value.length;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/has.js
// module id = 85
// module chunks = 35783957827783